window.components.contactForm = {
    init: function () {
        // console.log(`Component initialized: contactForm`);

    },
};
